// ── Brands ────────────────────────────────────────────────────────────────────
export const BRANDS = {
  goodVibes: {
    id: "goodVibes",
    name: "Good Vibes",
    tagBg: "#1a1a1a",
    tagColor: "#fff",
  },
  // Future brands:
  // streetKind: { id: "streetKind", name: "Street Kind", tagBg: "#3b5249", tagColor: "#fff" },
};

// ── Collections ───────────────────────────────────────────────────────────────
export const COLLECTIONS = [
  "All",
  "Soleil Collection",
  "Mellow Drop Collection",
  "Bare Skin Collection",
];

// ── Sizes (used by FilterBar) ─────────────────────────────────────────────────
export const SIZES = ["S", "M", "L", "XL", "2XL", "3XL"];

// ── Global color hex map (used by FilterBar swatches) ─────────────────────────
export const COLORS = [
  { name: "Brown", hex: "#7C5C4A" },
  { name: "White", hex: "#F2EDE8" },
  { name: "Beige", hex: "#C8B49A" },
  { name: "Pink",  hex: "#D4909A" },
  { name: "Black", hex: "#1A1A1A" },
];

// ── Products ──────────────────────────────────────────────────────────────────
// colors: array of { name, hex, image }
//   - name  → display name & filter matching
//   - hex   → swatch color
//   - image → photo shown when this color is selected
// When you upload real photos via the dashboard, just swap the image URLs here.
export const PRODUCTS = [
  {
    id: 1,
    type: "apparel",
    brand: "goodVibes",
    name: "Soleil Classic Tee",
    collection: "Soleil Collection",
    price: 5500,
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    colors: [
      { name: "Brown", hex: "#7C5C4A", image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600&q=80" },
      { name: "Beige", hex: "#C8B49A", image: "https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=600&q=80" },
      { name: "White", hex: "#F2EDE8", image: "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=600&q=80" },
    ],
  },
  {
    id: 2,
    type: "apparel",
    brand: "goodVibes",
    name: "Soleil Oversized",
    collection: "Soleil Collection",
    price: 6500,
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    colors: [
      { name: "Pink",  hex: "#D4909A", image: "https://images.unsplash.com/photo-1562157873-818bc0726f68?w=600&q=80" },
      { name: "White", hex: "#F2EDE8", image: "https://images.unsplash.com/photo-1571945153237-4929e783af4a?w=600&q=80" },
      { name: "Black", hex: "#1A1A1A", image: "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=600&q=80" },
    ],
  },
  {
    id: 3,
    type: "apparel",
    brand: "goodVibes",
    name: "Mellow Boxy Tee",
    collection: "Mellow Drop Collection",
    price: 5800,
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    colors: [
      { name: "Beige", hex: "#C8B49A", image: "https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=600&q=80" },
      { name: "Brown", hex: "#7C5C4A", image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600&q=80" },
    ],
  },
  {
    id: 4,
    type: "apparel",
    brand: "goodVibes",
    name: "Mellow Crop Top",
    collection: "Mellow Drop Collection",
    price: 5000,
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    colors: [
      { name: "Pink",  hex: "#D4909A", image: "https://images.unsplash.com/photo-1562157873-818bc0726f68?w=600&q=80" },
      { name: "White", hex: "#F2EDE8", image: "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=600&q=80" },
    ],
  },
  {
    id: 5,
    type: "apparel",
    brand: "goodVibes",
    name: "Bare Skin Essential",
    collection: "Bare Skin Collection",
    price: 5200,
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    colors: [
      { name: "White", hex: "#F2EDE8", image: "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=600&q=80" },
      { name: "Beige", hex: "#C8B49A", image: "https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=600&q=80" },
      { name: "Black", hex: "#1A1A1A", image: "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=600&q=80" },
    ],
  },
  {
    id: 6,
    type: "apparel",
    brand: "goodVibes",
    name: "Bare Skin Relaxed",
    collection: "Bare Skin Collection",
    price: 6000,
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    colors: [
      { name: "Brown", hex: "#7C5C4A", image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600&q=80" },
      { name: "Pink",  hex: "#D4909A", image: "https://images.unsplash.com/photo-1562157873-818bc0726f68?w=600&q=80" },
    ],
  },

  // ── Accessories (uncomment when ready) ────────────────────────────────────
  // {
  //   id: 7,
  //   type: "accessory",
  //   brand: "goodVibes",
  //   name: "AirPods Pro",
  //   collection: "Accessories",
  //   price: 120000,
  //   colors: [
  //     { name: "White", hex: "#F2EDE8", image: "..." },
  //   ],
  // },
];
